import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class CommonConfigService {
    getCNYMaskConfig() {
        return {
            mask: '¥num',
            blocks: {
                num: {
                    mask: Number,
                    thousandsSeparator: ',',
                    radix: '.',
                    mapToRadix: ['.'],
                    scale: 2,
                    signed: false,
                    normalizeZeros: true,
                    padFractionalZeros: true,
                    max: 9999999999.99,
                },
            },
        };
    }

    getPercentMaskConfig() {
        return {
            mask: [
                { mask: '' },
                {
                    mask: 'd%',
                    lazy: false,
                    blocks: {
                        d: {
                            mask: Number,
                            min: 0,
                            scale: 0,
                            signed: false,
                            thousandsSeparator: '',
                            normalizeZeros: true,
                        },
                    },
                },
            ],
        };
    }

    getPercentWithDecimalConfig() {
        return {
            mask: [
                { mask: '' },
                {
                    mask: 'd%',
                    lazy: false,
                    blocks: {
                        d: {
                            mask: Number,
                            min: 0,
                            scale: 2,
                            radix: '.',
                            thousandsSeparator: '',
                            normalizeZeros: true,
                            padFractionalZeros: true,
                            signed: false,
                        },
                    },
                },
            ],
        };
    }

    formatAmountInput(value: string) {
        if (!value) {
            return '';
        }

        const cleanedValue = value.replace(/[¥,_.]/g, '');
        if (cleanedValue === '') {
            return '';
        }

        const amount = parseFloat(value.replace(/[¥,_]/g, ''));
        return isNaN(amount) ? '' : amount.toFixed(2);
    }

    formatPercentInput(value: string) {
        if (!value) {
            return '';
        }

        let rate = (parseFloat(value.replace('%', '')) / 100).toFixed(4);
        return parseFloat(rate);
    }

    getNameMaskConfig() {
        return {
            mask: /^[A-Za-z\s\-]+$/,
            definitions: {
                'A-Z': /[A-Z]/,
                'a-z': /[a-z]/,
                '\s': /\s/,
                '-': /-/,
            },
        };
    }
}
